import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
} from '@cargomatic/ui';
import { Document } from './Document';

export function DocumentsList({
  isOrder,
  documents,
  deleteDisabled,
  onDeleteConfirm,
  onDeleteDecline,
  sentDocuments,
  loading,
}) {
  const { t } = useTranslation();
  const entity = isOrder ? 'order' : 'shipment';

  if (loading) {
    return <LoadingCircle text={t('LOADING')} />;
  }

  if (!documents || documents.length === 0) {
    return <i>{t('THIS_ENTITY_HAS_NO_DOCUMENTS', { entity })}</i>;
  }

  return (
    <div className="overflow-x-auto">
      <Table data-testid="shipment-documents-table">
        <TableHeader>
          <TableRow>
            <TableHead className="whitespace-nowrap">{t('DOCUMENT')}</TableHead>
            <TableHead className="whitespace-nowrap">{t('DATE_one')}</TableHead>
            <TableHead className="whitespace-nowrap">
              {t('SIGNATORY')}
            </TableHead>
            <TableHead className="whitespace-nowrap">{t('STATUS')}</TableHead>
            <TableHead className="whitespace-nowrap">{t('USER')}</TableHead>
            <TableHead>&nbsp;</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {documents.map((document, index) => (
            <Document
              key={document.id || index}
              isOrder={isOrder}
              document={document}
              deleteDisabled={deleteDisabled}
              onDeleteConfirm={onDeleteConfirm}
              onDeleteDecline={onDeleteDecline}
              isSent={Boolean(
                sentDocuments.find((doc) => doc.id === document.id),
              )}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
